import { withType } from "../../../../utils/actionOperations";
import { HANDLE_CHANGE_BECHMARK_FILTERING, REASSIGN_SAVED_DATA, RESET_ALL_STATE } from "../../../constants";

export const handleChangeBenchmarkFilter = (event) => {
    return dispatch => {
        dispatch(withType(HANDLE_CHANGE_BECHMARK_FILTERING, event));
    };
};

export const resetState = (event) => {
    return dispatch => {
        dispatch(withType(RESET_ALL_STATE, event));
    };
};

export const resetFilterContentsFromSavedData = (event) => {
    return dispatch => {
        dispatch(withType(REASSIGN_SAVED_DATA, event));
    };
}

